import ru from "../locales/countries/ru.json";

const locales = {
  RU: ru
};

export default function countryNameFilter(key, fallback) {
  const locale = "RU"; // static while one lang
  return locales[locale][key] || key || fallback;
}
